export type CspEnvironment = 'dev' | 'sit' | 'ppt' | 'prd' | 'test';

const isDevOrTest = (env: CspEnvironment): boolean => env === 'dev' || env === 'sit' || env === 'ppt' || env === 'test';

export const CspEnvironment = {
  isDevOrTest,
};
